import { baseCleanProps } from "common/api/Api";
import { fetcher } from "common/api/Fetcher";
import { IAuthorizedTokenData } from "common/records/AuthorizedToken";
import { ITokenData, TokenKind, TokenRecord } from "common/records/Token";

const url = "api/v1/orgs/:org_id/tokens";

export interface ITokenResponse {
  token: ITokenData;
}

export interface ITokenIndexResponse {
  tokens: ITokenData[];
}

export const loadAuthorized = (orgId: number): Promise<{ [k in TokenKind]: IAuthorizedTokenData }> => {
  const actionUrl = fetcher.joinUrls(url.replace(":org_id", orgId.toString()), "authorized");

  return fetcher.get(actionUrl);
};

export const list = (orgId: number): Promise<ITokenIndexResponse> => {
  const actionUrl = url.replace(":org_id", orgId.toString());

  return fetcher.get(actionUrl);
};

export const loadByKind = (orgId: number, tokenKind: TokenKind, parentTokenLoad: boolean): Promise<ITokenResponse> => {
  const params: { parent_token_load?: boolean } = {};
  if (parentTokenLoad) {
    params.parent_token_load = parentTokenLoad;
  }

  const actionUrl = fetcher.joinUrls(url.replace(":org_id", orgId.toString()), tokenKind);

  return fetcher.get(actionUrl, params);
};

export const create = (token: TokenRecord): Promise<ITokenResponse> => {
  const actionUrl = url.replace(":org_id", token.org_id.toString());

  return fetcher.post(actionUrl, token.toJS());
};

export const update = (token: TokenRecord): Promise<ITokenResponse> => {
  const actionUrl = fetcher.joinUrls(url.replace(":org_id", token.org_id.toString()), token.kind);

  return fetcher.patch(actionUrl, cleanProps(token));
};

export const deleteByKind = (orgId: number, tokenKind: TokenKind): Promise<ITokenResponse> => {
  const actionUrl = fetcher.joinUrls(url.replace(":org_id", orgId.toString()), tokenKind);

  return fetcher.delete(actionUrl);
};

export const cleanProps = (token: TokenRecord): Omit<ITokenData, "images"> => {
  const tokenParams = baseCleanProps(token.toJS() as any);

  delete tokenParams.valid_token;
  delete tokenParams.image_ids;

  if (tokenParams.data?.valid_types) {
    tokenParams.data.valid_types = token.data
      .get("valid_types")
      .map((type: string) => ({
        value: type,
      }))
      .toJS();
  }

  return tokenParams;
};
